// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZVkV9cU6vNpmhJ {
  display: flex;
  margin: 8px 0 12px;
}
.ZVkV9cU6vNpmhJ input {
  flex-grow: 1;
  width: 0;
  margin: 0;
}
.ZVkV9cU6vNpmhJ input:focus {
  border: none;
  background: var(--ds-surface, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.ZVkV9cU6vNpmhJ button {
  height: 32px;
  margin: 0;
  margin-left: 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shareLinkContainer": `ZVkV9cU6vNpmhJ`
};
export default ___CSS_LOADER_EXPORT___;
